import { values } from './enums'

const _enum = {
  Input: 0,
  Output: 1
}

export const reportType = {
  enumName: 'ReportType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportType.js